import advice from "../../../src/assets/sounds/lesson13/advice.mp3"
import ask from "../../../src/assets/sounds/lesson13/ask.mp3"
import can from "../../../src/assets/sounds/lesson13/can.mp3"
import dear_darling from "../../../src/assets/sounds/lesson13/dear_darling.mp3"
import difficult from "../../../src/assets/sounds/lesson13/difficult.mp3"
import first from "../../../src/assets/sounds/lesson13/first.mp3"
import go_straight from "../../../src/assets/sounds/lesson13/go_straight.mp3"
import hand_in from "../../../src/assets/sounds/lesson13/hand_in.mp3"
import homework from "../../../src/assets/sounds/lesson13/homework.mp3"
import little from "../../../src/assets/sounds/lesson13/little.mp3"
import many from "../../../src/assets/sounds/lesson13/many.mp3"
import propose from "../../../src/assets/sounds/lesson13/propose.mp3"
import really from "../../../src/assets/sounds/lesson13/really.mp3"
import show from "../../../src/assets/sounds/lesson13/show.mp3"
import suggest from "../../../src/assets/sounds/lesson13/suggest.mp3"
import take_care from "../../../src/assets/sounds/lesson13/take_care.mp3"
import turn_left from "../../../src/assets/sounds/lesson13/turn_left.mp3"
import turn_right from "../../../src/assets/sounds/lesson13/turn_right.mp3"
import way from "../../../src/assets/sounds/lesson13/way.mp3"

import advice_pic from "../../../src/assets/lesson13/advice_pic.png"
import ask_pic from "../../../src/assets/lesson13/ask_pic.png"
import can_pic from "../../../src/assets/lesson13/can_pic.png"
import dear_darling_pic from "../../../src/assets/lesson13/dear_darling_pic.png"
import difficult_pic from "../../../src/assets/lesson13/difficult_pic.png"
import first_pic from "../../../src/assets/lesson13/first_pic.png"
import go_straight_pic from "../../../src/assets/lesson13/way_pic.png"
import hand_in_pic from "../../../src/assets/lesson13/hand_in_pic.png"
import homework_pic from "../../../src/assets/lesson13/homework_pic.png"
import little_pic from "../../../src/assets/lesson13/little_pic.png"
import many_pic from "../../../src/assets/lesson13/many_pic.png"
import propose_pic from "../../../src/assets/lesson13/propose_pic.png"
import really_pic from "../../../src/assets/lesson13/really_pic.png"
import show_pic from "../../../src/assets/lesson13/show_pic.png"
import suggest_pic from "../../../src/assets/lesson13/suggest_pic.png"
import take_care_pic from "../../../src/assets/lesson13/take_care_pic.png"
import turn_left_pic from "../../../src/assets/lesson13/turn_left_pic.png"
import turn_right_pic from "../../../src/assets/lesson13/turn_right_pic.png"
import way_pic from "../../../src/assets/lesson13/way_pic.png"

export const unit_13=[
    {id: 0, english: "Can", vietnamese: "Có thể", example:"", audio:can, picture:can_pic},
    {id: 1, english: "Go straight", vietnamese: "Đi thẳng", example:"Đi thẳng", audio:go_straight, picture:go_straight_pic},
    {id: 2, english: "Turn right", vietnamese: "Rẽ/ phải", example:"Rẽ/ phải", audio:turn_right, picture:turn_right_pic},
    {id: 3, english: "Turn left", vietnamese: "Rẽ /trái", example:"Rẽ /trái", audio:turn_left, picture:turn_left_pic},
    {id: 4, english: "Difficult math", vietnamese: "Bài toán khó", example:"Bài toán khó", audio:difficult, picture:difficult_pic},
    {id: 5, english: "Way", vietnamese: "Đường / cách", example:"Đúng cách", audio:way, picture:way_pic},
    {id: 6, english: "Little ", vietnamese: "Một chút", example:"Một chút", audio:little, picture:little_pic},
    {id: 7, english: "Ask", vietnamese: "Hỏi", example:"Tự hỏi bản thân minh", audio:ask, picture:ask_pic},
    {id: 8, english: "Take care on your way", vietnamese: "Đi cẩn thận / hãy giữ gìn nhé", example:"Đi cẩn thận", audio:take_care, picture:take_care_pic},
    {id: 9, english: "Show", vietnamese: "Chỉ /bảo", example:"Cho tôi xem", audio:show, picture:show_pic},
    {id: 10, english: "Dear", vietnamese: "Con yêu", example:"Con yêu", audio:dear_darling, picture:dear_darling_pic},
    {id: 11, english: "Hand in", vietnamese: "Nộp", example:"Nộp", audio:hand_in, picture:hand_in_pic},
    {id: 12, english: "Many", vietnamese: "Nhiều", example:"Nhiều tiền", audio:many, picture:many_pic},
    {id: 13, english: "Homework", vietnamese: "Bài tập", example:"Tôi yêu bài tập về nhà", audio:homework, picture:homework_pic},
    {id: 14, english: "Advice", vietnamese: "Khuyên bảo", example:"Tôi xin lời khuyên", audio:advice, picture:advice_pic},
    {id: 15, english: "Reccomend", vietnamese: "Đề nghị", example:"Đề nghị", audio:propose, picture:propose_pic},
    {id: 16, english: "First", vietnamese: "Trước", example:"Trước", audio:first, picture:first_pic},
    {id: 17, english: "Really", vietnamese: "Vậy sao /thật à", excample:"Thật buồn cười", audio:really, picture:really_pic},
    {id: 18, english: "Suggest", vietnamese: "Gợi ý", example:"Gợi ý", audio:suggest, picture:suggest_pic},
]